import Button, { ButtonProps } from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import { forwardRef } from "react";
import { spaceBetween } from "../../../common/util/Array/spaceBetween";

type Props = { style?: BaseCSSProperties } & Omit<
    ButtonProps,
    "style" | "buttonRef"
>;

export const WhiteButton = forwardRef<HTMLButtonElement, Props>(
    ({ style, className, disabled, ...rest }, ref) => {
        const c = useStyles({ style, disabled });
        return (
            <Button
                variant="outlined"
                color="primary"
                {...rest}
                className={spaceBetween(className, c.button)}
                ref={ref}
                disabled={disabled}
            />
        );
    }
);
const useStyles = makeStyles<
    Theme,
    { style?: BaseCSSProperties; disabled?: boolean }
>(({ palette }) => ({
    button: ({ style, disabled }) => ({
        backgroundColor: disabled ? palette.grey[100] : "white",
        opacity: disabled ? 0.7 : 1,
        "&:hover": {
            backgroundColor: palette.grey[200],
        },
        fontSize: "medium",
        ...style,
    }),
}));
